export const getValuePlaceholder = (customPlaceholder = '-') =>
  customPlaceholder;
